import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalUrlService } from '@shared/services/externalurl.service';
import { IReport } from '@shared/services/report.service';
import { Subject, take } from 'rxjs';

@Component({
	selector: 'app-dialog-exturl',
	templateUrl: './dialog-exturl.component.html',
	styleUrls: ['./dialog-exturl.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DialogExturlComponent implements OnInit, OnDestroy {
	form: UntypedFormGroup;
	nameControl = new FormControl<string>('');
	urlControl = new FormControl<string>('');
	unsubscribe: Subject<void> = new Subject<void>();
	nameError = false;
	urlError = false;

	constructor(
		public dialogRef: MatDialogRef<DialogExturlComponent>,
		private externalUrlService: ExternalUrlService,
		@Inject(MAT_DIALOG_DATA) public data: IReport,
	) {
		this.form = new UntypedFormGroup({
			name: this.nameControl,
			url: this.urlControl,
		});
	}

	ngOnInit(): void {
		if (this.data) {
			this.nameControl.setValue(this.data.name);
			this.urlControl.setValue(this.data.url);
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	validateUrl(): boolean {
		const name = this.nameControl.value.trim();
		if (!name || name.length <= 0) {
			this.nameError = true;
			return false;
		}
		this.nameError = false;
		const url = this.urlControl.value.trim();
		if (!url || url.length <= 0) {
			this.urlError = true;
			return false;
		}
		if (!this.isHttpValid(url)) {
			this.urlError = true;
			return false;
		}
		this.nameError = false;
		return true;
	}

	saveExtUrl() {
		if (this.validateUrl()) {
			if (this.data) {
				this.data.name = this.nameControl.value.trim();
				this.data.url = encodeURIComponent(this.urlControl.value.trim());
				this.externalUrlService
					.updateExternalUrl(this.data)
					.pipe(take(1))
					.subscribe(() => {
						this.dialogRef.close();
					});
			} else {
				this.externalUrlService
					.addExternalUrl(this.nameControl.value.trim(), encodeURIComponent(this.urlControl.value.trim()))
					.pipe(take(1))
					.subscribe(() => {
						this.dialogRef.close();
					});
			}
		}
	}

	isHttpValid(str) {
		try {
			const newUrl = new URL(str);
			return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
		} catch (err) {
			console.log(err);
			return false;
		}
	}

	alphaNumberOnly(e) {
		// Accept only alpha numerics, not special characters
		const regex = /^[a-zæøå0-9 ]+$/i;
		const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
	}

	onPaste(e) {
		e.preventDefault();
		return false;
	}
}
